import {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {RadioFilterOption, RadioFilterPanel} from "./RadioFilterPanel";
import {RightSidebarPanelButton} from "./RightSidebarRail";
import {StayStatusFilterIcon} from "./StayStatusFilterIcon";

export type StayStatusFilterValue = "ALL" | "STAYING" | "CHECKING_IN" | "CHECKING_OUT";

interface StayStatusRailFilterProps {
    value: StayStatusFilterValue;
    onChange: (value: StayStatusFilterValue) => void;
}

export function StayStatusRailFilter({value, onChange}: StayStatusRailFilterProps) {
    const {t} = useTranslation();
    const options = useMemo<readonly RadioFilterOption<StayStatusFilterValue>[]>(() => [
        {value: "ALL", label: t("All profiles")},
        {value: "STAYING", label: t("In-House")},
        {value: "CHECKING_IN", label: t("Checking in")},
        {value: "CHECKING_OUT", label: t("Checking out")},
    ], [t]);

    return (
        <RightSidebarPanelButton
            icon={<StayStatusFilterIcon active={value !== "ALL"}/>}
            label={t("Status")}
            renderPanel={close => (
                <RadioFilterPanel<StayStatusFilterValue>
                    title={t("Status")}
                    options={options}
                    value={value}
                    onChange={onChange}
                    onReset={value === "ALL" ? undefined : () => onChange("ALL")}
                    onClose={close}
                />
            )}
        />
    );
}
